export default __webpack_public_path__ + "static/media/internet-travail.aa15ba4b.png";